var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    { staticClass: "custom-fieldset" },
    [
      _c("legend", [_vm._v("Odcinek nr " + _vm._s(_vm.partIndex + 1))]),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Przewoźnik*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.carrier,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "carrier", $$v)
                  },
                  expression: "contextPart.carrier"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Numer lotu",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.part.flight_number,
                  callback: function($$v) {
                    _vm.$set(_vm.part, "flight_number", $$v)
                  },
                  expression: "part.flight_number"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: _vm.baggageRules,
                  label: "Bagaż rejestrowany",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.baggage,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "baggage", $$v)
                  },
                  expression: "contextPart.baggage"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Termin wylotu*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.start_date,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "start_date", $$v)
                  },
                  expression: "contextPart.start_date"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Termin lądowania*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.end_date,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "end_date", $$v)
                  },
                  expression: "contextPart.end_date"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Klasa*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.seat_class,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "seat_class", $$v)
                  },
                  expression: "contextPart.seat_class"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Skąd*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.from,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "from", $$v)
                  },
                  expression: "contextPart.from"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Dokąd*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.to,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "to", $$v)
                  },
                  expression: "contextPart.to"
                }
              })
            ],
            1
          ),
          _vm.showReturnCheckbox
            ? _c(
                "v-col",
                { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
                [
                  _c("v-checkbox", {
                    ref: "checkboxReturnRoute",
                    attrs: {
                      rules: _vm.returnRouteCheckboxRules,
                      label: "Trasa powrotna",
                      readonly:
                        _vm.$store.state.AdminTravelService.isOfferReadonly
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("returnRouteCheckboxReValidate")
                      }
                    },
                    model: {
                      value: _vm.contextPart.is_return_route,
                      callback: function($$v) {
                        _vm.$set(_vm.contextPart, "is_return_route", $$v)
                      },
                      expression: "contextPart.is_return_route"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { cols: "12" } },
            [
              _c("v-textarea", {
                attrs: {
                  label: "Komentarz",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.comment,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "comment", $$v)
                  },
                  expression: "contextPart.comment"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }